import React from "react";
import "./styles.css";

function isControlledProp(props, key) {
  return props[key] !== undefined;
}

function getState(state, props) {
  return Object.keys(state).reduce((prevState, key) => {
    prevState[key] = isControlledProp(props, key) ? props[key] : state[key];

    return prevState;
  }, {});
}

function capitalizeString(string) {
  return `${string.slice(0, 1).toUpperCase()}${string.slice(1)}`;
}

function callOnChangeProps(action, state, newState) {
  const { props, type } = action;
  const changes = {};

  Object.keys(state).forEach(key => {
    invokeOnChangeHandler(key, props, state, newState);

    if (newState[key] !== state[key]) {
      changes[key] = newState[key];
    }
  });

  if (props.onStateChange && Object.keys(changes).length) {
    props.onStateChange({ type, ...changes });
  }
}

function invokeOnChangeHandler(key, props, state, newState) {
  const handler = `on${capitalizeString(key)}Change`;
  if (
    props[handler] &&
    newState[key] !== undefined &&
    newState[key] !== state[key]
  ) {
    props[handler](newState);
  }
}

function useEnhancedReducer(reducer, initialState, props) {
  const [state, setState] = React.useState(initialState);

  const dispatch = action => {
    console.log("useFixedReducer:dispatch");

    const { stateReducer: stateReduceLocal } = action.props;
    const changes = reducer(state, action);
    const newState = stateReduceLocal(state, { ...action, changes });

    callOnChangeProps(action, state, newState);

    setState(newState);
  };

  return [getState(state, props), dispatch];
}

function checkboxReducer(state, action) {
  return {
    ...state,
    checked: !state.checked
  };
}

function stateReducer(s, a) {
  return a.changes;
}

function Checkbox(props) {
  const [{ checked }, dispatch] = useEnhancedReducer(
    checkboxReducer,
    { checked: false },
    props
  );

  console.log("render: checked", checked);

  return (
    <div
      style={{
        cursor: "pointer",
        height: 20,
        width: 20,
        border: "2px solid green",
        ...(checked && { background: "green" })
      }}
      onClick={() => {
        console.log("onClick");
        dispatch({ props });
      }}
    >
      {props.children}
    </div>
  );
}

Checkbox.defaultProps = {
  stateReducer,
  onCheckedChange: () => {}
};

//

export default function App() {
  const [checked, setChecked] = React.useState(false);

  return (
    <div className="App">
      <h2>fixed useEnhancedReducer</h2>

      <Checkbox
        checked={checked}
        onCheckedChange={a => {
          console.log("onCheckedChange");
          setChecked(a.checked);
        }}
      />
    </div>
  );
}
